import { JobLookupField } from "@gui/widgets/JobLookup";
import { darkInputSx } from "./toolbarStyles";
import type { ToolbarJobSearchVM } from "./ToolbarJobSearch.vm";

// On the AppBar: white-on-dark like the selectors beside it, and a miss's message floats under the bar on a paper
// backing instead of growing the bar to fit it.
const ON_APP_BAR_SX = {
	flex: "0 1 380px",
	minWidth: 240,
	mr: 2,
	...darkInputSx,
	"& .MuiFormHelperText-root": {
		position: "absolute",
		top: "100%",
		mt: 0.5,
		mx: 0,
		px: 1,
		py: 0.25,
		bgcolor: "background.paper",
		borderRadius: 1,
		boxShadow: 2,
		whiteSpace: "nowrap",
		zIndex: 1,
	},
} as const;

/** The Job Detail page's job search, in the toolbar. Desktop sits on the AppBar; mobile stacks in the overflow menu. */
export function ToolbarJobSearch({ vm, onAppBar }: { vm: ToolbarJobSearchVM; onAppBar: boolean }) {
	return (
		<JobLookupField
			value={vm.value}
			onValueChange={vm.setValue}
			onFound={vm.onFound}
			hideSubmit
			fullWidth
			stacked={!onAppBar}
			sx={onAppBar ? ON_APP_BAR_SX : undefined}
		/>
	);
}
